import React from 'react';
import ReactDOM from 'react-dom';
import ButtonList from '../Button/ButtonList';
import { cmpContext,existButton } from './function';
class IndexFooter extends React.Component {
    constructor(props) {
        super(props);
        this.registFooterAnimation = this.registFooterAnimation.bind(this);
        this.removeFooterAnimation = this.removeFooterAnimation.bind(this);
    }

    componentDidMount() {
        this.getInitStyle();
    }

    componentDidUpdate() {
        this.getInitStyle();
    }

    getDomHeight(dom) {
        return ReactDOM.findDOMNode(dom) && ReactDOM.findDOMNode(dom).offsetHeight || 0;
    }

    getInitStyle() {
        this.footerHeight = this.getDomHeight(this.refs.indexFooter);
    }

    transformHandler() {
        if(this.footerIndex === -1) {
            this.changeFooterWrapIndex();
        }
    }

    // 监听按钮底部动画
    registFooterAnimation(footer) {
        if(footer) {
            this.indexFooter = footer;
            footer.addEventListener('webkitTransitionEnd', e => { //动画结束时事件
                this.transformHandler();
            }, false);
        }
    }

    removeFooterAnimation(footer) {
        if(footer) {
            footer.removeEventListener('webkitTransitionEnd',() => {
                this.transformHandler();
            },false);
        }
    }

    changeFooterStyle(style) {
        if(this.indexFooter) {
            const { transform = `translateY(${this.footerHeight}px)`,zIndex } = style;
            this.indexFooter.style.transform = transform;
            this.indexFooter.style.WebkitTransform = transform;
            this.footerIndex = zIndex;
            /* 按钮隐藏时 由于transform只是视觉位移 元素其实还在页面底部 会使页面底部无法进行点击操作
                所以按钮隐藏时降index 使其层级降低至页面下
                注意： 需要等transform动画执行完  才可以降index 不然就没有动画效果
            */
            if(zIndex === 0) {
                // 按钮显示时 应该直接设置index 为 0
                this.changeFooterWrapIndex();
            }
        }
    }

    changeFooterWrapIndex() {
        this.refs.footerWrap && (this.refs.footerWrap.style.zIndex = this.footerIndex);
    }

    getButtonList() {
        const { indexData,actions,queryUrl,getSearchCondition,reloadTable,currentDetailPageViewName,getScrollTop } = this.props;
        if(window.parent != window.self || !existButton(indexData)) {
            return null;
        }
        let currentViewName = '';
        let pageName = '';        // 操作日志pageName
        try {
            currentViewName = indexData.NavView.cmp_data.currentViewName;
            pageName = indexData.NavView.biz_data[currentViewName].text;
        } catch(e) {
            // console.info('fail to get currentViewName');
        }

        return (<ButtonList ref='indexFooter' wrapFooterCls='transition-wrap'
                    {...indexData.ButtonList}
                    actions={actions}
                    data={indexData.TableList}
                    cmpContext={cmpContext(indexData,queryUrl)}
                    queryUrl={queryUrl}
                    afterAction={reloadTable}
                    getScrollTop={getScrollTop}
                    searchCriteria={getSearchCondition()}
                    tabelListPostParam={indexData.TableList && indexData.TableList.cmp_data}
                    pageCode={currentDetailPageViewName() || currentViewName}
                    pageName={pageName}
                    registEvent={this.registFooterAnimation}
                    removeEvent={this.removeFooterAnimation} />);
    }

    render() {
        let buttonList;
		if(!this.props.errors) {
			buttonList = this.getButtonList();
		}
        return <div className="index-footer" ref="footerWrap">{buttonList}</div>;
    }

}

IndexFooter.defaultProps = {
    indexData: {}
};
export default IndexFooter;



// WEBPACK FOOTER //
// ./src/components/Pages/IndexFooter.js